import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { translations } from '../Text/translations';
import { buildLogoutUrl } from '../../../../../utils/authHelper';
import BoxIcon from '../../../../../images/icon/icon-box.svg';
import NowidIcon from '../../../../../images/icon/icon-nowid.svg';
import CartIcon from '../../../../../images/icon/icon-cart.svg';
import WhatsappIcon from '../../../../../images/icon/icon-whatsapp.svg';
import phoneCallIcon from '../../../../../images/icons/phone-call.svg';
import maxActivationImage from '../../assets/max/Max-Activation.png';

const MaxEnquiry = ({ currentLang, mobilenowid, emailnowid, learnMoreUrl,isEmailVerified, loginUrl }) => {
// const liveChatBtnRef = useRef(null);

  const handleLearnMoreButtonClick = () => {
    window.location.href = learnMoreUrl;
  };

  const handleLearnMoreHereClick = () => {
    currentLang === 'en' ? window.open("https://www.nowe.com/serviceenhancementhbomax?locale=en") : window.open("https://www.nowe.com/serviceenhancementhbomax?locale=zh");
  };
  const handleFindYourSubscriptionClick = () => {
    const callback = encodeURIComponent(window.location.href);
    const targetRedirect = currentLang === 'en'
      ? `https://tvbinding.now.com/verifynowidpa/en/index.jsp?callback=${callback}`
      : `https://tvbinding.now.com/verifynowidpa/zh/index.jsp?callback=${callback}`;

    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('redemptionCode');
    }

    window.location.href = buildLogoutUrl(currentLang, targetRedirect);
  };
  const handleWhatsappClick = () => {
    window.location.href = "https://api.whatsapp.com/send?phone=85296133533&text=%E6%88%91%E6%83%B3%E6%9F%A5%E8%A9%A2%E9%97%9C%E6%96%BCHBO+Max%E4%B9%8B%E7%9B%B8%E9%97%9C%E7%B5%84%E5%90%88%E8%A9%B3%E6%83%85%E3%80%82+I+would+like+to+inquire+the+details+of+Now+TV+x+HBO+Max+service+plan.&utm_source=DiscoverPage&utm_medium=Banner&utm_campaign=DiscoverPage";
  };
/*
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('src');
    source = source ? "_" + source : "";
    const paramName = "Nowtv_max" + source;

    axios.get(`https://nowplayer.now.com/livechat/renderLiveChatButton`, {
      params: {
        m_n: paramName,
        l: currentLang,
        e_s: "nowtv.now.com"
      }
    }).then(response => {
      // Remove 'null(' at the start and ')' at the end, then parse the remaining string
      const responseData = JSON.parse(response.data.slice('null('.length, -1));
      // console.log('chat', responseData);
      const liveChatBtn = liveChatBtnRef.current;
      if (liveChatBtn && responseData.liveChatButtonHtml) {
        // Extract the URL from the liveChatButtonHtml string
        const urlMatch = responseData.liveChatButtonHtml.match(/window.open\('([^']*)'/);
        if (urlMatch && urlMatch[1]) {
          const url = urlMatch[1];
          // Set up the click event handler here
          liveChatBtn.onclick = (e) => {
            e.preventDefault(); // prevent the default action
            // Open the chat box in a new window
            window.open(url, '_blank');
          };
        }
      }
    }).catch(e => {
      console.log(e);
    });
  }, [currentLang]);
*/
  return (
    <>
    <div className="data-box">
        <div className="container">
          <h4>{translations[currentLang].maxLoggedInWithNowID}</h4>
          <b>{isEmailVerified ? (emailnowid || mobilenowid) : mobilenowid}</b>
        </div>
    </div>

    <div className="no-subscription-wrapper">
      <div className="container">
        <p>{translations[currentLang].maxNoSubscription}</p>
        <div className="fix-options">
          <div className="item">
            <h5> <img src={BoxIcon} alt="" /> {translations[currentLang].maxOptionTitle1}</h5>
            <a onClick={handleFindYourSubscriptionClick} className="btn outline">{translations[currentLang].maxOptionContent1}</a>
          </div>
          <div className="item">
            <h5> <img src={NowidIcon} alt="" /> {translations[currentLang].maxOptionTitle2}</h5>
            <a href={loginUrl} className="btn outline">{translations[currentLang].maxOptionContent2}</a>
          </div>
        </div>

      </div>
    </div>

    <div className="max-contact-wrapper">
      <div className="container">
        <hr/>
        <h3>{translations[currentLang].maxContactUs}</h3>

        <div className="contact-items-wrapper">
          <div className="item">
              <a onClick={handleLearnMoreButtonClick}>
                <div className="img-wrap"><img src={CartIcon} alt="" className="cart" /></div>
                <h5>{translations[currentLang].maxSubscribeOnline}</h5>
              </a>
          </div>

          <div className="item">
              <a onClick={handleWhatsappClick}>
                <div className="img-wrap"><img src={WhatsappIcon} alt="" className="whatsapp" /></div>
                <h5>{translations[currentLang].maxWhatsAppEnquiry}</h5>
              </a>
          </div>

          <div className="item">
              <a href={currentLang === 'en' ? "tel:28880008" : "tel:28881888"}>
                <div className="img-wrap"><img src={phoneCallIcon} alt="" className="phone" /></div>
                <h5>{translations[currentLang].maxCall}<br />{translations[currentLang].maxDial}</h5>
              </a>
          </div>
        </div>

        <div className="notes">
          <p>{translations[currentLang].maxNowEUser}<br/><a onClick={handleLearnMoreHereClick}>{translations[currentLang].maxLearnMoreHere}</a>{translations[currentLang].maxAboutYourMaxAccountActivation}</p>
        </div>

        <img src={maxActivationImage} alt="" className="preview-img" />

      </div>
    </div>
    </>
  );
};

export default MaxEnquiry;